import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import axios from 'axios';
import ResponsiveAppBar from "../ResponsiveAppBar"
import ResponsiveFooter from "../ResponsiveFooter";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import * as constants from "../constants.js"

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const resp = await axios.create({
                    withCredentials: true,
                }).get("//" + constants.BASE_URL + "/@me");
            } catch (error) {
                navigate('/login');
            }
        })();
    }, []);

    const cardStyle = {
        borderRadius: '10px', // Adjust the value to control the roundness of the corners
        // You can also add other styles like backgroundColor, boxShadow, etc.
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'oldPassword') {
            setOldPassword(value);
        } else if (name === 'newPassword') {
            setNewPassword(value);
        } else if (name === 'newPasswordRepeat') {
            setNewPasswordRepeat(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const resp = await axios.create({
                withCredentials: true,
            }).post("//" + constants.BASE_URL + "/change_user_password", {
                oldPassword,
                newPassword,
                newPasswordRepeat,
            });
            console.log('Password changed successfully:', resp.data);
            setOldPassword('');
            setNewPassword('');
            setNewPasswordRepeat('');
            setMessage(resp.data.success);
            setSeverity('success');
            setOpen(true);
        } catch (error) {
            if (error.response) {
                setMessage(error.response.data.error);
            } else if (error.request) {
                setMessage('The request was made but no response was received');
            } else {
                setMessage('An error occurred');
            }
            setSeverity('error');
            setOpen(true);
        }
    };

    return (
        <div className="home">
            <ResponsiveAppBar />
            <div className="body-content">
                <br></br>
                <h2>Passwort ändern</h2>
                <br></br>
                <Container maxWidth="sm" style={{ marginTop: '20px' }}>
                    {error && <Typography variant="body1" style={{ color: 'red' }}>{error}</Typography>}
                    <Card style={cardStyle}>
                        <CardContent>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            label="Altes Passwort"
                                            variant="outlined"
                                            name="oldPassword"
                                            value={oldPassword}
                                            onChange={handleChange}
                                            style={{ marginBottom: '16px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            label="Neues Passwort"
                                            variant="outlined"
                                            name="newPassword"
                                            value={newPassword}
                                            onChange={handleChange}
                                            style={{ marginBottom: '16px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            label="Passwort bestätigen"
                                            variant="outlined"
                                            name="newPasswordRepeat"
                                            value={newPasswordRepeat}
                                            onChange={handleChange}
                                            style={{ marginBottom: '16px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button variant="contained" color="primary" type="submit">
                                            Passwort ändern
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                    <br></br>
                    <Button
                        variant="contained"
                        color="grey"
                        onClick={() => { navigate('/user/preferences'); }}
                    >
                        Zurück
                    </Button>
                </Container>

                <Snackbar open={open} autoHideDuration={6000} onClose={handleSnackbarClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={severity}>
                        {message}
                    </MuiAlert>
                </Snackbar>
            </div>
            <ResponsiveFooter />
        </div>
    );
};

export default ChangePassword;
